module.exports = __webpack_public_path__ + "img/DE01137.40d9eeba.png";